import React from 'react';
import WebTopBar from '../components/WebTopBar.js';
import TopGroovesRanking from '../components/TopGroovesRanking.js';

/**
 * Ranking completo de Grooves (semana / mes / año).
 */
export default function PageGroovesRanking({ onBack, onNavigate, user }) {
  return (
    <div style={{ background: '#0a0a0f', minHeight: '100vh' }}>
      <WebTopBar navActive="comunidad" dark user={user} onNavigate={onNavigate} onSignOut={onBack} />
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '24px 20px 48px' }}>
        <button
          type="button"
          onClick={() => onNavigate?.('comunidad')}
          style={{
            marginBottom: 16,
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid rgba(255,255,255,0.12)',
            background: 'rgba(255,255,255,0.04)',
            color: 'rgba(255,255,255,0.7)',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          ← Volver a Comunidad
        </button>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.5 }}>
          Clasificación por Grooves ganados en el período. Solo cuentas con teléfono verificado.
        </p>
        <TopGroovesRanking onNavigate={onNavigate} limit={100} showViewFullLink={false} listMaxHeight={null} />
      </div>
    </div>
  );
}
